import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  OutlinedInput,
} from "@mui/material";

export default function MuiSelect({
  onFilterChange,
  options = [],
  value = "",
  label = "",
  sx = {},
  multiple = false,
}) {
  const normalizeMultiple = (v) => {
    if (v == null || v === "") return [];
    if (Array.isArray(v)) return v.map(String);
    if (typeof v === "string" && v.includes(",")) {
      return v
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    return [String(v)];
  };

  const [filter, setFilter] = useState(() =>
    multiple ? normalizeMultiple(value) : (value ?? ""),
  );

  useEffect(() => {
    if (multiple) {
      setFilter(normalizeMultiple(value));
    } else {
      setFilter(value ?? "");
    }
  }, [value, multiple]);

  const handleChange = (event) => {
    const next = event.target.value;
    setFilter(next);
    onFilterChange?.(next);
  };

  const renderMultipleValue = (selected) => {
    const ids = selected || [];
    if (ids.length === 0) return "";
    const labels = ids
      .map((id) =>
        options.find((o) => String(o.value) === String(id)),
      )
      .filter(Boolean)
      .map((o) => o.label);
    return labels.join(", ");
  };

  return (
    <FormControl
      size="small"
      sx={{ minWidth: multiple ? 280 : 200, ...sx }}
      className="bg-white"
    >
      <InputLabel id="filter-label">{label}</InputLabel>
      <Select
        labelId="filter-label"
        multiple={multiple}
        value={filter}
        label={label}
        onChange={handleChange}
        input={multiple ? <OutlinedInput label={label} /> : undefined}
        renderValue={multiple ? renderMultipleValue : undefined}
      >
        {options?.map(({ label: optionLabel, value: optionValue }, index) => (
          <MenuItem
            key={`${String(optionValue)}-${String(optionLabel)}-${index}`}
            value={optionValue}
          >
            {multiple && (
              <Checkbox
                size="small"
                checked={
                  Array.isArray(filter) &&
                  filter.some((v) => String(v) === String(optionValue))
                }
              />
            )}
            <span className={multiple ? "ml-1" : undefined}>{optionLabel}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
